export default __webpack_public_path__ + "static/media/bl-sprites.c83d8e66.jpg";